import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../components/onboard-section/messages';

export const useShipFromData = () => {
  const sellerShipFroms = useSelector(Global.selectSellerShipFroms);

  return useMemo(() => {
    const connectedShipFromsData = sellerShipFroms.map((location) => {
      const { originAddress } = location;
      return {
        name: location.name,
        id: location.shipFromId,
        connectedDescription: {
          messageDescriptor: messages.connectedAddress,
          values: {
            line1: originAddress.line1,
            line2: originAddress.line2,
            city: originAddress.city,
            state: originAddress.state,
            postal: originAddress.postalCode,
          },
        },
      };
    });

    return {
      isShipFromComplete: connectedShipFromsData.length > 0,
      connectedShipFromsData,
    };
  }, [sellerShipFroms]);
};
